import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';

import Stream from 'flarum/common/utils/Stream';
import withAttr from 'flarum/common/utils/withAttr';
import ItemList from 'flarum/common/utils/ItemList';
import AgreementModal from 'flarum/forum/components/AgreementModal';

export default class FlagPostModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    this.success = false;

    this.reason = Stream('');
    this.reasonDetail = Stream('');
  }

  className() {
    return 'FlagPostModal Modal--medium';
  }

  title() {
    return app.translator.trans('flarum-flags.forum.flag_post.title');
  }

  content() {
    if (this.success) {
      return (
        <div className="Modal-body">
          <div className="Form Form--centered">
            <p className="helpText">{app.translator.trans('flarum-flags.forum.flag_post.confirmation_message')}</p>
            <div className="Form-group">
              <Button className="Button Button--primary Button--block" onclick={this.hide.bind(this)}>
                {app.translator.trans('flarum-flags.forum.flag_post.dismiss_button')}
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="Modal-body">
        <div className="Form Form--centered">
          <div className="Form-group">
            <div>{this.flagReasons().toArray()}</div>
          </div>

          <div className="Form-group">
            <Button className="Button Button--primary Button--block" type="submit" loading={this.loading} disabled={this.loading}>
              {app.translator.trans('flarum-flags.forum.flag_post.submit_button')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  flagReasons() {
    const items = new ItemList();

    items.add(
      'off-topic',
      <label className="checkbox">
        <input type="radio" name="reason" checked={this.reason() === 'off_topic'} value="off_topic" onclick={withAttr('value', this.reason)} />
        <strong>{app.translator.trans('flarum-flags.forum.flag_post.reason_off_topic_label')}</strong>
        {app.translator.trans('flarum-flags.forum.flag_post.reason_off_topic_text')}
        {this.reason() === 'off_topic' && (
          <div className="textarea-box">
            <textarea
            className="FormControl"
            maxlength="1000"
            placeholder={app.translator.trans('flarum-flags.forum.flag_post.reason_details_placeholder')}
            value={this.reasonDetail()}
            oninput={withAttr('value', this.reasonDetail)}
            ></textarea>
            <span className="charCount">{this.reasonDetail()?this.reasonDetail().length:0} / 1000</span>
          </div>
        )}
      </label>,
      70
    );
    let baseUrl = app.forum.attribute('baseUrl');
    let ruleLink = app.data.pkgLogo.ruleLink;
    let localeRuleLink = '';
    if (ruleLink) {
      // 将字符串映射转换为 JavaScript 对象
      const obj = JSON.parse(ruleLink);
      // 创建 Map 对象并初始化
      const map = new Map(Object.entries(obj));
      // 获取特定键的值
      localeRuleLink = map.get(app.data.locale);
    }
    items.add(
      'inappropriate',
      <label className="checkbox">
        <input
          type="radio"
          name="reason"
          checked={this.reason() === 'inappropriate'}
          value="inappropriate"
          onclick={withAttr('value', this.reason)}
        />
        <strong>{app.translator.trans('flarum-flags.forum.flag_post.reason_inappropriate_label')}</strong>
        {app.translator.trans('flarum-flags.forum.flag_post.reason_inappropriate_text', {
          a: <a target="_blank"  href={localeRuleLink
            ?  localeRuleLink.includes('http')
              ? localeRuleLink
              : baseUrl + localeRuleLink
            : '#'}  />,
        })}
        {this.reason() === 'inappropriate' && (
          <div className="textarea-box">
            <textarea
              className="FormControl"
              maxlength="1000"
              placeholder={app.translator.trans('flarum-flags.forum.flag_post.reason_details_placeholder')}
              value={this.reasonDetail()}
              oninput={withAttr('value', this.reasonDetail)}
            ></textarea>
            <span className="charCount">{this.reasonDetail()?this.reasonDetail().length:0} / 1000</span>
          </div>
        )}
      </label>,
      60
    );

    items.add(
      'spam',
      <label className="checkbox">
        <input type="radio" name="reason" checked={this.reason() === 'spam'} value="spam" onclick={withAttr('value', this.reason)} />
        <strong>{app.translator.trans('flarum-flags.forum.flag_post.reason_spam_label')}</strong>
        {app.translator.trans('flarum-flags.forum.flag_post.reason_spam_text')}
        {this.reason() === 'spam' && (
          <div className="textarea-box">
            <textarea
              className="FormControl"
              maxlength="1000"
              placeholder={app.translator.trans('flarum-flags.forum.flag_post.reason_details_placeholder')}
              value={this.reasonDetail()}
              oninput={withAttr('value', this.reasonDetail)}
            ></textarea>
            <span className="charCount">{this.reasonDetail()?this.reasonDetail().length:0} / 1000</span>
          </div>
        )}
      </label>,
      50
    );

    items.add(
      'avatar-violation',
      <label className="checkbox">
        <input type="radio" name="reason" checked={this.reason() === 'avatar_violation'} value="avatar_violation" onclick={withAttr('value', this.reason)} />
        <strong>{app.translator.trans('flarum-flags.forum.flag_post.reason_avatar_violation_label')}</strong>
        {app.translator.trans('flarum-flags.forum.flag_post.reason_avatar_violation_text')}
        {this.reason() === 'avatar_violation' && (
          <div className="textarea-box">
            <textarea
              className="FormControl"
              maxlength="1000"
              placeholder={app.translator.trans('flarum-flags.forum.flag_post.reason_details_placeholder')}
              value={this.reasonDetail()}
              oninput={withAttr('value', this.reasonDetail)}
            ></textarea>
            <span className="charCount">{this.reasonDetail()?this.reasonDetail().length:0} / 1000</span>
          </div>
        )}
      </label>,
      40
    );

    items.add(
      'nickname-violation',
      <label className="checkbox">
        <input type="radio" name="reason" checked={this.reason() === 'nickname_violation'} value="nickname_violation" onclick={withAttr('value', this.reason)} />
        <strong>{app.translator.trans('flarum-flags.forum.flag_post.reason_nickname_violation_label')}</strong>
        {app.translator.trans('flarum-flags.forum.flag_post.reason_nickname_violation_text')}
        {this.reason() === 'nickname_violation' && (
          <div className="textarea-box">
            <textarea
              className="FormControl"
              maxlength="1000"
              placeholder={app.translator.trans('flarum-flags.forum.flag_post.reason_details_placeholder')}
              value={this.reasonDetail()}
              oninput={withAttr('value', this.reasonDetail)}
            ></textarea>
            <span className="charCount">{this.reasonDetail()?this.reasonDetail().length:0} / 1000</span>
          </div>
        )}
      </label>,
      30
    );

    items.add(
      'signature-violation',
      <label className="checkbox">
        <input type="radio" name="reason" checked={this.reason() === 'signature_violation'} value="signature_violation" onclick={withAttr('value', this.reason)} />
        <strong>{app.translator.trans('flarum-flags.forum.flag_post.reason_signature_violation_label')}</strong>
        {app.translator.trans('flarum-flags.forum.flag_post.reason_signature_violation_text')}
        {this.reason() === 'signature_violation' && (
          <div className="textarea-box">
            <textarea
              className="FormControl"
              maxlength="1000"
              placeholder={app.translator.trans('flarum-flags.forum.flag_post.reason_details_placeholder')}
              value={this.reasonDetail()}
              oninput={withAttr('value', this.reasonDetail)}
              ></textarea>
            <span className="charCount">{this.reasonDetail()?this.reasonDetail().length:0} / 1000</span>
          </div>
        )}
      </label>,
      20
    );

    items.add(
      'other',
      <label className="checkbox">
        <input type="radio" name="reason" checked={this.reason() === 'other'} value="other" onclick={withAttr('value', this.reason)} />
        <strong>{app.translator.trans('flarum-flags.forum.flag_post.reason_other_label')}</strong>
        {this.reason() === 'other' && (
          <div className="textarea-box">
            <textarea
              required
              className="FormControl"
              maxlength="1000"
              placeholder={app.translator.trans('dl-response.forum.flagPostModal.reason_details_placeholder')}
              value={this.reasonDetail()}
              oninput={withAttr('value', this.reasonDetail)}
            ></textarea>
            <span className="charCount">{this.reasonDetail()?this.reasonDetail().length:0} / 1000</span>
          </div>
        )}
      </label>,
      10
    );

    return items;
  }

  onsubmit(e) {
    e.preventDefault();

    this.loading = true;

    app.store
      .createRecord('flags')
      .save(
        {
          reason: this.reason() === 'other' ? null : this.reason(),
          reasonDetail: this.reasonDetail(),
          relationships: {
            user: app.session.user,
            post: this.attrs.post,
          },
        },
        { errorHandler: this.onerror.bind(this) }
      )
      .then(() => (this.success = true))
      .catch(() => {})
      .then(this.loaded.bind(this));
  }
}
